import React, { useState, useEffect } from 'react';
import Sidepage from './Sidepage';

//loading bar
import { makeStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';

import '../css/loading-page.css';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2)
    }
  }
}));

function Loading(props) {
  const classes = useStyles();
  const [completed, setCompleted] = useState(0);
  const [moveSlide, setMoveSlide] = useState(false);
  const [moveButton, setMoveButton] = useState(false);

  useEffect(() => {
    function progress() {
      setCompleted(oldCompleted => {
        if (oldCompleted === 100) {
          //animation transition
          setMoveSlide(true);
          setMoveButton(true);
          props.setShowMenu(true);
          return;
        }
        const diff = Math.floor(Math.random() * 31) + 28;

        return Math.min(oldCompleted + diff, 100);
      });
    }

    const timer = setInterval(progress, 500);

    return () => {
      clearInterval(timer);
      props.setShowMenu(false);
    };
  }, []);

  return (
    <section id='loading-page'>
      <div className={classes.root}>
        <Sidepage moveButton={moveButton} />
        <div id='preloader' className={moveSlide ? 'move-slide' : null}>
          <img className='logo' src='./logo3.png' alt='jamie-sparker-logo' />
          <LinearProgress variant='determinate' value={completed} />
        </div>
      </div>
    </section>
  );
}

export default Loading;
